import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["smsLabelElement", "whatsappLabelElement", "recurringPurchaseHiddenContainerSms", "recurringPurchaseHiddenContainerWhatsapp", "whatsappNumberField", "smsNumberField", "recurringPurchaseSubmitButton", "remainingWhatsApp", "remainingBonusWhatsApp", "remainingSms", "remainingBonusSms", "recurringPurchaseWarningContainer"]

  connect() {
    if(this.smsLabelElementTarget.checked) {
      this.recurringPurchaseHiddenContainerSmsTarget.classList.toggle("hide")
      this.smsNumberFieldTarget.required = true
    }
    if(this.whatsappLabelElementTarget.checked) {
      this.recurringPurchaseHiddenContainerWhatsappTarget.classList.toggle("hide")
      this.whatsappNumberFieldTarget.required = true
    }
    this.enableImmediatePurchaseAlert()
  }

  toggleHideSms() {
    this.recurringPurchaseHiddenContainerSmsTarget.classList.toggle("hide")
    this.smsNumberFieldTarget.required = true
    if(this.smsLabelElementTarget.checked) {
      this.smsNumberFieldTarget.required = false
      this.smsNumberFieldTarget.value = ""
    }
    this.enableImmediatePurchaseAlert()
  }

  toggleHideWhatsapp() {
    this.recurringPurchaseHiddenContainerWhatsappTarget.classList.toggle("hide")
    this.whatsappNumberFieldTarget.required = true
    if(this.whatsappLabelElementTarget.checked) {
      this.whatsappNumberFieldTarget.required = false
      this.whatsappNumberFieldTarget.value = ""
    }
    this.enableImmediatePurchaseAlert()
  }

  enableImmediatePurchaseAlert() {
    if(this.whatsappLabelElementTarget.checked || this.smsLabelElementTarget.checked) {
      if(parseInt(this.remainingWhatsAppTarget.name.replace(/\D/g,'')) + parseInt(this.remainingBonusWhatsAppTarget.name.replace(/\D/g,'')) <= parseInt(this.whatsappNumberFieldTarget.value) || parseInt(this.remainingSmsTarget.name.replace(/\D/g,'')) + parseInt(this.remainingBonusSmsTarget.name.replace(/\D/g,'')) <= parseInt(this.smsNumberFieldTarget.value)) {
        this.recurringPurchaseWarningContainerTarget.classList.remove("hide")
      }
      else {
        this.recurringPurchaseWarningContainerTarget.classList.add("hide")
      }
    }
  }
}
